import React from "react";
import "../styles/formProgress.css";

export default function FormProgress({ formData, primarySkills, secondarySkills, mindteckExp, totalExp }) {
    const totalFields = 12;
    let filledFields = 0;

    // Count filled fields
    if (formData.role) filledFields++;
    if (formData.domain) filledFields++;
    if (formData.serviceLine) filledFields++;
    if (formData.location) filledFields++;
    if (mindteckExp.years || mindteckExp.months) filledFields++;
    if (totalExp.years || totalExp.months) filledFields++;
    primarySkills.forEach((s) => { if (s.skill) filledFields++; if (s.level) filledFields++; });
    secondarySkills.forEach((s) => { if (s.skill) filledFields++; if (s.level) filledFields++; });
    if (formData.certification) filledFields++;
    if (formData.trainingReceived) filledFields++;
    if (formData.trainingRequirement) filledFields++;

    const progressPercent = Math.min(Math.round((filledFields / totalFields) * 100), 100);

    return (
        <div className="form-progress-container">
            <div className="form-progress-meta">
                <span className="form-progress-label">Form completion</span>
                <span className="form-progress-value num">{progressPercent}%</span>
            </div>
            <div
                className="progress-bar-background"
                role="progressbar"
                aria-valuenow={progressPercent}
                aria-valuemin={0}
                aria-valuemax={100}
                aria-label="Form completion"
            >
                <div
                    className={`progress-bar-fill ${progressPercent === 100 ? "complete" : ""}`}
                    style={{ width: `${progressPercent}%` }}
                ></div>
            </div>
        </div>
    );
}
